import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VuePlyr from 'vue-plyr'
import VueScrollTo from 'vue-scrollto'
import VueWaypoint from 'vue-waypoint'
import VueCookies from "vue-cookies"
import VueGtag from "vue-gtag"

import 'vue-plyr/dist/vue-plyr.css'

Vue.config.productionTip = false

Vue.use(VueWaypoint)
Vue.use(VuePlyr)
Vue.use(VueScrollTo)
Vue.use(VueCookies)

Vue.use(VueGtag, {
  bootstrap: false,
  config: {
    id: 'G-L2CZPT2YZ8',
    params: {
      anonymize_ip: true
    }
  }
}, router)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
